import React from "react";
import Facts from "components/Facts";
import map from "../map";

import { addRoundedRect } from "./svgUtils";
import { mapDefs } from "../render";

const appSize = 50;

export default {
  hasData: true,
  hasRag: true,
  collections: {
    envs: { objectType: "env" },
  },

  layout: { radius: (appSize / 2) * 1.42 * 0.9 },
  render: {
    enter: ({ elem: e, label }) => {
      const logo = "https://infrared.blob.core.windows.net/apps/icons/" + label;

      const clipPathName = "appClipPath";
      const svgDefs = mapDefs();
      const pathSel = svgDefs.selectAll("#" + clipPathName);
      if (pathSel.length == 0) {
        addRoundedRect(
          svgDefs.append("clipPath").attr("id", clipPathName),
          0,
          0,
          appSize,
          appSize,
          10,
          0.5
        );
      }

      addRoundedRect(
        e,
        -(appSize / 2),
        -(appSize / 2),
        appSize,
        appSize,
        10,
        0.5
      ).attr("class", "whiteFill");

      const g = e
        .append("g")
        .attr(
          "transform",
          "translate(" + -(appSize / 2) + "," + -(appSize / 2) + ")"
        )
        .attr("clip-path", "url(#" + clipPathName + ")");

      g.append("image")
        .attr("href", logo)
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", appSize)
        .attr("height", appSize);

      g.append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", appSize)
        .attr("height", appSize)
        .attr("class", "whiteFade");

      const tg = g.append("g");

      const t = tg.append("text").attr("class", "appName").text(label);

      const is = 1;
      const sz = t.getBBox();
      const wd = sz.width;
      const ht = sz.height + sz.y / 2;

      const md = wd > ht ? wd : ht;
      const scale = (appSize - is * 2) / md;
      const xo = is;
      const yo = appSize / 2 + (ht / 2) * scale;
      tg.attr(
        "transform",
        "translate(" + xo + "," + yo + ") scale(" + scale + ")"
      );
    },
  },

  renderInfoHead: (t) => t.data || "(No full name)",
  renderInfoBody: (t) => (
    <Facts>
      <Facts.Fact label="Abbreviation" value={t.label} />
      <Facts.Fact label="Environments" value={getEnvironments(t)} />
      <Facts.Fact label="App versions" value={getAppVersions(t)} />
      <Facts.Fact label="Saffron versions" value={getSaffVersions(t)} />
    </Facts>
  ),
};

function getEnvironments(t) {
  return t.children.map((c) => c.label).join(", ");
}

function getAppVersions(t) {
  return (
    Object.keys(map.objects)
      .filter((k) => k.startsWith(t.id))
      .map((k) => map.objects[k])
      .filter((o) => o.type == "process" && o.data)
      .map((o) => JSON.parse(o.data).appVersion)
      .filter((v) => v)
      .reduce(
        (p, c) => (p == "" ? c : p.indexOf(c) == -1 ? p + ", " + c : p),
        ""
      ) || "Unknown"
  );
}

function getSaffVersions(t) {
  return (
    Object.keys(map.objects)
      .filter((k) => k.startsWith(t.id))
      .map((k) => map.objects[k])
      .filter((o) => o.type == "process" && o.data)
      .map((o) => JSON.parse(o.data).saffronVersion)
      .filter((v) => v)
      .reduce(
        (p, c) => (p == "" ? c : p.indexOf(c) == -1 ? p + ", " + c : p),
        ""
      ) || "Unknown"
  );
}
